<mat-toolbar class="subtitulo">Movimentações</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px"
    (selectionChange)="carregarContasBancarios($event)">

        <!------------------ MOVIMENTAÇÃO ------------------------>
        <mat-step [stepControl]="formDadosMovimentacao">
            <form #formDadosMovimentacao="ngForm">
                <ng-template matStepLabel>MOVIMENTAÇÃO</ng-template>
                <dados-movimentacao [movimentacoes]="movimentacoes" 
                                    [perfilAcesso]="perfilAcesso"
                                    [tributos]="tributos">
                </dados-movimentacao>
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                    fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>

        <!-- ------------------ ITENS  ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formItens">
            <form #formItens="ngForm">
                <ng-template matStepLabel>ITENS</ng-template>
                <itens-movimentacao [movimentacoes]="movimentacoes"
                                    [tributos]="tributos"
                                    [perfilAcesso]="perfilAcesso">
                </itens-movimentacao>
            </form>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!-- ------------------ ATIVO / PASSIVO  ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formAtivoPassivo">
            <form #formAtivoPassivo="ngForm">
                <ng-template matStepLabel>MOVIMENTAÇÃO CONTÁBIL</ng-template>
                <categorias-movimentos [movimentacoes]="movimentacoes"
                                       [perfilAcesso]="perfilAcesso"
                                       (onCategoriaMovimentoInvalido)="getValorTotalCategoriasMovimentosInvalidos($event)">
                </categorias-movimentos>
            </form>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>
        
        <!-- ------------------ FATURAS ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formFaturas">
            <form #formFaturas="ngForm">
                <ng-template matStepLabel>FATURAS</ng-template>
                <faturas-movimentacao [movimentacoes]="movimentacoes"
                                      [perfilAcesso]="perfilAcesso"
                                      (onValorTotalFaturaInvalidos)="getValorTotalFaturasInvalidos($event)"
                 ></faturas-movimentacao>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!------------------ PAGAMENTOS ------------------------>
        <mat-step style="padding-bottom: 20px" [stepControl]="formPagamentos">
            <form #formPagamentos="ngForm">
                <ng-template matStepLabel>{{getLabelABA()}}</ng-template>
                <pagamentos-movimentacao [idMovimentacao]="movimentacoes.id"
                                         [movimentacoes]="movimentacoes"
                                         [perfilAcesso]="perfilAcesso"
                                         [contasBancarias]="contasBancarias"
                                         (onPagamentoInvalido)="getPagamentoInvalido($event)"
                ></pagamentos-movimentacao>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

    </mat-horizontal-stepper>
</div>



 <!-- BOTOES -->
 <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" 
            [disabled]="formDadosMovimentacao.invalid || formItens.invalid || formAtivoPassivo.invalid || formFaturas.invalid || formPagamentos.invalid || isDesabilitaBotao()"
            mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="cadastrar()">
            Cadastrar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" 
            [disabled]="formDadosMovimentacao.invalid || formItens.invalid || formAtivoPassivo.invalid || formFaturas.invalid || formPagamentos.invalid || isDesabilitaBotao()"
            mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="atualizar()">
            Atualizar
    </button>

    <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
    </button>
    <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
    </button>

</div>
